import { all, put, select, takeLatest } from 'redux-saga/effects';

// Actions:
import { setPopupState } from 'src/store/popup/slice';
import { createCertificateFailedAction } from '../store/certificate/sagaActions';
import { goToOrderAction } from '../store/view/sagaActions';

// Selectors
import {
  selectOrderID,
  selectOrderPin,
} from '../../../store/payment/selectors';
import { sendCertificateFailAnalytics } from './certificate';

/**
 * Переброс на страницу окончательного заказа
 */

function* goToOrderPage() {
  const id = yield select(selectOrderID);
  const pin = yield select(selectOrderPin);
  const redirectUrl = `/orders/${id}?pin=${pin}`;
  window.location.href = redirectUrl;
}

function* showErrorPopupHandler(action) {
  yield put(setPopupState('error'));
  yield sendCertificateFailAnalytics(action);
}

export default function* certificateViewSaga() {
  yield all([
    takeLatest([createCertificateFailedAction], showErrorPopupHandler),
    takeLatest(goToOrderAction, goToOrderPage),
  ]);
}
